import { AuthContext } from 'auth/SessionProvider';
import { useContext } from 'react';

export const useAuth = () => useContext(AuthContext);
